import { createFileRoute } from '@tanstack/react-router';
import { TimesheetAdmin } from '@/features/timesheet/TimesheetAdmin';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { MobileTimesheetAdmin } from '@/features/timesheet/mobile/MobileTimesheetAdmin';

export const Route = createFileRoute('/_app/timesheet/admin')({ component: TimesheetAdminPage });

/** Selettore mobile/desktop: su telefono le cinque schede diventano un segmented scorrevole. */
function TimesheetAdminPage() {
  const isMobile = useIsMobileShell();
  return isMobile ? <MobileTimesheetAdmin /> : <TimesheetAdmin />;
}

// Admin rendicontazione: timesheet-templates / timesheet-closure-periods /
// timesheet-attribute-definitions (CRUD JSON:API via schema condiviso).
